var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSystemSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 14.25C12.98 14.25 14 13.23 14 12C14 10.77 12.98 9.75 11.75 9.75C10.52 9.75 9.5 10.77 9.5 12C9.5 13.23 10.52 14.25 11.75 14.25Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 32.25C12.98 32.25 14 31.23 14 30C14 28.77 12.98 27.75 11.75 27.75C10.52 27.75 9.5 28.77 9.5 30C9.5 31.23 10.52 32.25 11.75 32.25Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 50.25C12.98 50.25 14 49.23 14 48C14 46.77 12.98 45.75 11.75 45.75C10.52 45.75 9.5 46.77 9.5 48C9.5 49.23 10.52 50.25 11.75 50.25Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 23.25V5.25C45.5 4.05 45.02 2.91 44.18 2.07C43.34 1.23 42.2 0.75 41 0.75H5C3.8 0.75 2.66 1.23 1.82 2.07C0.98 2.91 0.5 4.05 0.5 5.25V54.75C0.5 55.95 0.98 57.09 1.82 57.93C2.66 58.77 3.8 59.25 5 59.25H41V54.75H5V41.25H23V36.75H5V23.25H45.5ZM5 5.25H41V18.75H5V5.25Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40.68V37.35H55.19C55.01 36.36 54.47 35.34 53.93 34.35L56.66 31.83L54.14 29.49L51.41 32.01C50.51 31.5 49.43 31.02 48.14 30.84V27.33H44.51V30.84C43.43 31.02 42.35 31.5 41.24 32.01L38.51 29.49L35.99 31.83L38.72 34.35C38.18 35.19 37.64 36.18 37.46 37.35H33.65V40.68H37.46C37.64 41.67 38.18 42.69 38.72 43.68L35.99 46.2L38.51 48.54L41.24 46.02C42.14 46.53 43.22 47.01 44.51 47.19V50.7H48.14V47.19C49.22 47.01 50.3 46.53 51.41 46.02L54.14 48.54L56.66 46.2L53.93 43.68C54.47 42.84 55.01 41.85 55.19 40.68H59ZM46.34 44.04C43.25 44.04 40.91 41.88 40.91 39.03C40.91 36.18 43.25 34.02 46.34 34.02C49.43 34.02 51.77 36.18 51.77 39.03C51.77 41.88 49.43 44.04 46.34 44.04Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSystemSettings);
export default __webpack_public_path__ + "static/media/ic-system-settings.75f04c96f4221146374f00201346bbaf.svg";
export { ForwardRef as ReactComponent };